import React from "react";
import {Typography, withStyles} from "@material-ui/core";
import styles from "./styles";
import PropTypes from "prop-types";
import {pseudoText, pseudoTitle} from "../../constants";

const TitleWithTextComponent = ({classes, title, text, titleSize}) => (
    <div className={classes.root}>
        <Typography className={classes.title} align={"center"} style={{fontSize: titleSize}}>{title}</Typography>
        <Typography className={classes.subText} align={"center"} dangerouslySetInnerHTML={{__html: text}}/>
    </div>
);

TitleWithTextComponent.propTypes = {
    titleSize: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    title: PropTypes.string,
    text: PropTypes.string,
};

TitleWithTextComponent.defaultProps = {
    title: pseudoTitle,
    text: pseudoText,
};

export default withStyles(styles)(TitleWithTextComponent)